/* Warm the selected product gallery after the server-rendered hero has painted. */
(function () {
  function start() {
    var root = document.querySelector('.product[id^="ProductSection-"]');
    if (!root || /\/products\/spencer-air-ergonomic-chair\/?$/.test(location.pathname)) return;
    if (window.__shappaProductGalleryWarmStarted) return;
    window.__shappaProductGalleryWarmStarted = true;
    var gallery = root.querySelector('.mySwiper2');
    if (!gallery) return;

    var queue = [];
    var active = 0;
    var ready = false;
    var slides = function () {
      return Array.prototype.slice.call(gallery.querySelectorAll('.swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)'));
    };
    var hero = gallery.querySelector('.swiper-slide:first-child img');

    function finish(image) {
      active -= 1;
      var wrapper = image.closest('[data-product-single-media-wrapper]');
      if (wrapper && image.naturalWidth) wrapper.classList.remove('hide');
      pump();
    }
    function load(image, urgent) {
      if (!image || !image.isConnected || image.dataset.galleryWarmStarted || (image.complete && image.naturalWidth)) return;
      image.dataset.galleryWarmStarted = 'true';
      active += 1;
      image.loading = 'eager';
      image.decoding = 'async';
      image.fetchPriority = urgent ? 'high' : 'low';
      var done = false;
      function once() {
        if (done) return;
        done = true;
        image.removeEventListener('load', onload);
        image.removeEventListener('error', once);
        if (image.decode && image.naturalWidth) image.decode().then(function () { finish(image); }, function () { finish(image); });
        else finish(image);
      }
      function onload() { once(); }
      image.addEventListener('load', onload, { once: true });
      image.addEventListener('error', once, { once: true });
      if (image.complete) once();
    }
    function pump() {
      if (!ready || document.visibilityState === 'hidden') return;
      while (active < 2 && queue.length) load(queue.shift(), false);
    }
    function warmUpcoming() {
      if (!ready || document.visibilityState === 'hidden') return;
      var list = slides();
      var activeIndex = gallery.swiper ? gallery.swiper.realIndex : 0;
      list.forEach(function (slide, index) {
        if (index === activeIndex) return;
        var image = slide.querySelector('.product-single__media img');
        if (image && image.isConnected && !image.complete && queue.indexOf(image) < 0 && !image.dataset.galleryWarmStarted) {
          queue.push(image);
        }
      });
      pump();
    }
    function loadActiveSlide() {
      var activeSlide = gallery.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)') || gallery.querySelector('.swiper-slide-active');
      if (activeSlide) load(activeSlide.querySelector('.product-single__media img'), true);
    }
    function begin() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ready = true;
          warmUpcoming();
        });
      });
    }

    if (!hero || (hero.complete && hero.naturalWidth)) begin();
    else {
      hero.addEventListener('load', begin, { once: true });
      hero.addEventListener('error', begin, { once: true });
    }
    root.addEventListener('pointerover', function (event) {
      var thumb = event.target.closest('[data-product-thumbnails] [data-thumb-index]');
      if (!thumb) return;
      var target = slides()[Number(thumb.getAttribute('data-thumb-index'))];
      if (target) load(target.querySelector('.product-single__media img'), true);
    });
    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-product-thumbnails] [data-thumb-index]');
      if (!thumb) return;
      var target = slides()[Number(thumb.getAttribute('data-thumb-index'))];
      if (target) load(target.querySelector('.product-single__media img'), true);
    });
    root.addEventListener('focusin', function (event) {
      var thumb = event.target.closest('[data-product-thumbnails] [data-thumb-index]');
      if (!thumb) return;
      var target = slides()[Number(thumb.getAttribute('data-thumb-index'))];
      if (target) load(target.querySelector('.product-single__media img'), true);
    });
    root.addEventListener('touchstart', function (event) {
      var thumb = event.target.closest('[data-product-thumbnails] [data-thumb-index]');
      if (!thumb) return;
      var target = slides()[Number(thumb.getAttribute('data-thumb-index'))];
      if (target) load(target.querySelector('.product-single__media img'), true);
    }, { passive: true });
    function bindSwiper() {
      if (!gallery.swiper || gallery.swiper._galleryWarmBound) return;
      gallery.swiper._galleryWarmBound = true;
      gallery.swiper.on('slideChange', function () {
        loadActiveSlide();
        warmUpcoming();
      });
    }
    bindSwiper();
    if (!gallery.swiper) {
      var observer = new MutationObserver(function () {
        if (!gallery.swiper) return;
        bindSwiper();
        warmUpcoming();
      });
      observer.observe(gallery, { attributes: true, attributeFilter: ['class'] });
    }
    var form = root.querySelector('form.product-form');
    if (form) form.addEventListener('change', function () {
      queue = queue.filter(function (image) { return image.isConnected; });
      window.setTimeout(function () { bindSwiper(); loadActiveSlide(); warmUpcoming(); }, 300);
    });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') warmUpcoming(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
